import React, { Component } from "react";
import { connect } from "react-redux";
import * as postActions from "../../store/action/post";
import * as configActions from "../../store/action/config";
import ApiService from "../../services/ApiService";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import NormalEditorTypePage from "./normal-editor-type-page";
import SpecialEditorTypePage from "./special-editor-type-page";
import MiniEditorTypePage from "./mini-editor-type-page";
import ShowbizTypeNormal from "./showbiz-type-normal";
import ShowbizTypeFull from "./showbiz-type-full";

const PROJECT = process.env.REACT_APP_PROJECT;
const LIST_PROJECTS = {
  saostar: {
    'normal': NormalEditorTypePage,
    'special': SpecialEditorTypePage,
    'mini': MiniEditorTypePage,
    'video': NormalEditorTypePage,
    'short': NormalEditorTypePage,
    'podcast': NormalEditorTypePage
  },
  
  showbiz: {
    'normal': ShowbizTypeNormal,
    'special': ShowbizTypeFull,
    'mini': ShowbizTypeFull,
    // 'video': ShowbizEditorTypeNormal
  }
};

class PreviewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      postContent: {},
      isMobile:false
    };
  }

  componentDidMount() {
    let idPage = window.location.pathname.replace("/preview/", "");
    
    let isMobile = window.location.search.replace("?isMobile=", "");
    
    ApiService.get("/posts/" + idPage).then(result => {
      if (result._id) {
        this.setState({ postContent: result });
        if(isMobile){
          this.setState({ isMobile: isMobile });
        }
      } else {
        this.confirmAction();
      }
    });
  }

  confirmAction() {
    const options = {
      title: "Title",
      message: "Message",
      buttons: [
        {
          label: "Yes",
          onClick: () => alert("Click Yes")
        }
      ],
      childrenElement: () => <div />,
      customUI: ({ onClose }) => (
        <div className="custom-ui-alert">
          <h1>Không tìm thấy bài viết này.</h1>
          <div
            className="bg-c7c6c5 bg-c7c6c5 txt-center pt-3 pb-3"
            onClick={() => {
              onClose();
              window.location.href = "/";
            }}
          >
            Trở lại
          </div>
        </div>
      ),
      closeOnEscape: false,
      closeOnClickOutside: false
    };

    confirmAlert(options);
  }

  getPreviewTemplate(editorType, listTemplates) {
    if (editorType) {
      
      return listTemplates[editorType];
    }
  }

  render() {
    let {
      postContent,
      isMobile,
      postContent: {
        editor_type
      }
    } = this.state;

    let project = 'saostar';
    if (PROJECT in LIST_PROJECTS) {   
      project = PROJECT;
    }

    const Template = this.getPreviewTemplate(editor_type, LIST_PROJECTS[project]);
    if (Template) {
      return <Template postContent={postContent} isMobile={isMobile} />
    }

    return <></>;
  }
}

export default connect(
  store => {
    return {
      login: store.loginInfo,
      config: store.config,
      post: store.post
    };
  },
  dispatch => {
    return {
      createPost: value => {
        dispatch(postActions.createPost(value));
      },
      getPostById: value => {
        dispatch(postActions.getPostById(value));
      },
      updatePost: value => {
        dispatch(postActions.updatePost(value));
      }
    };
  }
)(PreviewPage);
